module.exports = __webpack_public_path__ + "static/media/ico_profile.abe7f070.svg";